import { useEffect, useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { getConnectivityStatus, subscribeConnectivity } from '../../connectivity/connectivityInfra';
import { spacing } from '../../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors'
import { typography } from '../../../shared/theme/typography';
import { isWebOnlineWritesActive } from '../../feature-flags/webOnlineWrites';
import { getCachedGlobalFeatureFlagsForSync } from '../../feature-flags/globalFeatureFlagsService';

/**
 * Indicador global cuando no hay ruta a internet; no bloquea interacción.
 * Permite dismiss temporal (vuelve a aparecer si sigue offline).
 */
export function OfflineConnectionBanner() {
  const [offline, setOffline] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [webBlocksOfflineWrites, setWebBlocksOfflineWrites] = useState(() =>
    isWebOnlineWritesActive(getCachedGlobalFeatureFlagsForSync()),
  );

  useEffect(() => {
    const sub = subscribeConnectivity((status) => {
      const noNet = !status.isOnline || !status.isInternetReachable;
      setOffline(Boolean(noNet));
      if (!noNet) {
        setDismissed(false);
      }
    });
    void getConnectivityStatus().then((status) => {
      setOffline(!status.isOnline || !status.isInternetReachable);
    });
    return () => sub();
  }, []);

  useEffect(() => {
    const tick = () => {
      setWebBlocksOfflineWrites(isWebOnlineWritesActive(getCachedGlobalFeatureFlagsForSync()));
    };
    tick();
    const id = setInterval(tick, 15_000);
    return () => clearInterval(id);
  }, []);

  if (!offline || dismissed) return null;

  const text = webBlocksOfflineWrites
    ? 'Sin conexión. Cuando vuelva internet, cobrá con el mismo botón.'
    : 'Sin conexión. Las operaciones necesitan internet para confirmarse.';

  return (
    <View style={styles.wrap} accessibilityRole="alert">
      <Text style={styles.text}>{text}</Text>
      <TouchableOpacity
        onPress={() => setDismissed(true)}
        style={styles.dismissButton}
        hitSlop={{ top: 8, right: 8, bottom: 8, left: 8 }}
      >
        <Ionicons name="close" size={16} color={ticketColors.ink2} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: ticketColors.paper,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    ...typography.caption,
    color: ticketColors.ink2,
    flex: 1,
    fontFamily: ticketFonts.sans,
  },
  dismissButton: {
    marginLeft: spacing.sm,
    padding: spacing.xs,
  },
});
